import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';
import { getSession, isAdmin } from '../../lib/adminAuth';

// 'loading' | 'authorized' | 'unauthorized'
function useAdminGate() {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;

    async function check() {
      const session = await getSession();
      if (!session) {
        if (active) setStatus('unauthorized');
        return;
      }

      // Estar autenticado no basta: hace falta estar dado de alta como admin.
      const admin = await isAdmin();
      if (active) setStatus(admin ? 'authorized' : 'unauthorized');
    }

    check();

    return () => {
      active = false;
    };
  }, []);

  return status;
}

export default function ProtectedAdminRoute({ children }) {
  const status = useAdminGate();

  if (status === 'loading') {
    // No redirigir mientras se resuelve la sesión: si no, un usuario ya
    // autenticado quedaría expulsado en cada recarga.
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minH="60vh"
      >
        <Spinner size="xl" color="accent.default" thickness="3px" />
      </Box>
    );
  }

  if (status === 'unauthorized') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
